import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { Icon } from '../Icon';
import styles from './Toast.module.css';
function ToastComponent(props) {
    const { isVisible, onClose, dataTestId, className, message, placement = 'bottom-center' } = props;
    if (!isVisible)
        return null;
    const placementClassName = placement === 'top-right' ? styles.toastTopRight : '';
    return (_jsx("div", { className: `${styles.toast} ${placementClassName} ${className ?? ''}`, "data-testid": dataTestId, children: _jsxs("div", { className: styles.content, children: [_jsx("div", { className: styles.icon, children: _jsx(Icon, { name: 'successGreen' }) }), _jsx("div", { className: styles.message, children: message }), _jsx("button", { className: styles.closeButton, onClick: onClose, "data-testid": `${dataTestId}-close`, children: _jsx(Icon, { name: 'actionClose' }) })] }) }));
}
export const Toast = memo(ToastComponent);
